module.exports = __webpack_public_path__ + "img/8bce6712b80a8933ddd618806afdbf4d.ba16363e.jpg";